<template>
  <section class="section-b-space about-us">
    <div class="container">
      <div class="row">
        <div class="col-md-6">
          <div class="us-img">
            <img :src="contentImage" alt="" class="img-fluid us-w" />
          </div>
        </div>
        <div class="col-md-6">
          <div class="trending-blog">
            <div class="blog-title">
              <h2>{{ _T(contentHeading) }}</h2>
            </div>
            <p v-html="contentText">
            </p>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import { mapGetters } from 'vuex'
export default {
  name: 'ContentPart',
  props: {
    contentHeading: {
      type: String,
      default: '',
    },
    contentText: {
      type: String,
      default: '',
    },
    contentImage: {
      type: String,
      default: '',
    },
  },
  computed: {
    ...mapGetters(['_T']),
  },
}
</script>

<style lang="scss" scoped>
.about-us {
  .us-img {
    position: relative;
    margin-bottom: $px90;
    .us-w {
      width: 94%;
    }
    .us-back {
      opacity: 0.2;
      z-index: -1;
      position: absolute;
      bottom: -$px90;
      left: -$px60;
    }
  }
  .trending-blog {
    .blog-title {
      h2 {
        text-align: left;
        margin-bottom: calc(
          #{$px20} + (42 - 20) * ((100vw - #{$px320}) / (1920 - 320))
        );
        &::after {
          margin: 0;
        }
      }
    }
    p {
      font-size: $px16;
      line-height: $px29;
      letter-spacing: 0.005em;
      margin-bottom: 0;
    }
  }
  &.how-work {
    .v2-work-img {
      img {
        transform: scaleX(-1);
      }
    }
    .row {
      align-items: center;
    }
  }
}
@media (max-width: 1366px) {
  .about-us {
    .us-img {
      margin-bottom: $px74;
      .us-back {
        bottom: -$px75;
        left: -$px38;
      }
    }
  }
}
@media (max-width: 1199px) {
  .about-us {
    .us-img {
      margin-bottom: $px48;
      .us-w {
        width: 100%;
      }
      .us-back {
        width: 32%;
        bottom: -$px48;
        left: -$px25;
      }
    }
  }
}
@media (max-width: 991px) {
  .about-us {
    .trending-blog {
      p {
        font-size: $px14;
        line-height: $px26;
      }
    }
  }
}
@media (max-width: 767px) {
  .about-us {
    .us-img {
      margin-bottom: $px85;
    }
  }
}
@media (max-width: 575px) {
  .about-us {
    .us-img {
      margin-bottom: $px30;
      .us-back {
        display: none;
      }
    }
  }
}
</style>
